module.exports = __webpack_public_path__ + "static/media/flask.6daa80cf.png";